function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 15.456c7.5 0 10.5-7.5 10.5-7.5s-3-7.5-10.5-7.5S.5 7.956.5 7.956s3 7.5 10.5 7.5zm0-4.5a3 3 0 100-6 3 3 0 000 6z",
  fill: "#81858D"
});

var SvgVisibility = function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAxNS40NTYxQzE4LjUgMTUuNDU2MSAyMS41IDcuOTU2MDUgMjEuNSA3Ljk1NjA1QzIxLjUgNy45NTYwNSAxOC41IDAuNDU2MDU1IDExIDAuNDU2MDU1QzMuNSAwLjQ1NjA1NSAwLjUgNy45NTYwNSAwLjUgNy45NTYwNUMwLjUgNy45NTYwNSAzLjUgMTUuNDU2MSAxMSAxNS40NTYxWk0xMSAxMC45NTYxQzEyLjY1NjkgMTAuOTU2MSAxNCA5LjYxMjkxIDE0IDcuOTU2MDVDMTQgNi4yOTkyIDEyLjY1NjkgNC45NTYwNSAxMSA0Ljk1NjA1QzkuMzQzMTUgNC45NTYwNSA4IDYuMjk5MiA4IDcuOTU2MDVDOCA5LjYxMjkxIDkuMzQzMTUgMTAuOTU2MSAxMSAxMC45NTYxWiIgZmlsbD0iIzgxODU4RCIvPgo8L3N2Zz4=";
export { SvgVisibility as ReactComponent };